import { useCallback, useMemo } from 'react'

import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

import { customBannerMessageDsClass } from './product-custom-banner-message-ds.styles'
import { getTrackerAddedComboMessageOffer } from './utils'

import type { ProductCustomBannerMessageProps } from './product-custom-banner-message.types'

// DS twin of legacy `ProductCustomBannerMessage` — identical logic + telemetry, legacy SCSS box
// swapped for the Panda `customBannerMessageDsClass` (V2-unconditional; legacy V2 only toggled width).
export const ProductCustomBannerMessageDS = (props: ProductCustomBannerMessageProps) => {
  const { productId, customBannerMessageFromPC } = props
  const getIsVisibleTrackParams = useCallback(
    () => ({
      action: 'pdp_custom_banner_message',
      value: true,
      context: {
        productId,
      },
    }),
    [productId],
  )
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  const customBannerMessageWithTracker = useMemo(
    () =>
      customBannerMessageFromPC && productId
        ? getTrackerAddedComboMessageOffer(customBannerMessageFromPC, productId as number)
        : customBannerMessageFromPC,
    [customBannerMessageFromPC, productId],
  )

  return (
    <>
      {!props.hideCustomBannerMessage && customBannerMessageWithTracker && productId && (
        <div className={customBannerMessageDsClass} ref={trackIsVisibleRef}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(customBannerMessageWithTracker),
            }}
          ></div>
        </div>
      )}
    </>
  )
}
